(ns app.events
  (:require [ajax.core :as ajax]
            [app.strive-forms.events :as forms-events]
            [app.dashboard.events :as wevents :refer [get-token]]
            [app.db :as db]
            [app.endpoints :refer [reauthenticate]]
            [day8.re-frame.http-fx]
            [day8.re-frame.tracing :refer-macros [fn-traced]]
            [jwt-decode]
            [re-frame.core :as re-frame :refer [reg-sub]]
            [re-posh.core :as re-posh]
            [clojure.walk]
            [jwt-decode]))

(re-frame/reg-event-db
 ::initialize-db
 (fn-traced [_ _]
            db/default-db))

(re-posh/reg-event-ds
 ::initialize-ds
 (fn-traced [_ _]
            db/default-ds))
(re-frame/reg-event-db
 ::set-ds
 (fn-traced [db [_ ds]]
            (assoc db :ds ds)))

(re-frame/reg-event-fx
 ::navigate
 (fn-traced [_ [_ handler]]
            {:navigate handler}))

(re-frame/reg-event-fx
 ::set-active-panel
 (fn-traced [{:keys [db]} [_ active-panel]]
            {:db (assoc db :active-panel active-panel)}))

(defn parse-params
  "Parse URL parameters into a hashmap"
  []
  (->> js/window
       (.-location)
       (.-search)
       (new js/URLSearchParams)
       (seq)
       (js->clj)
       (into {})
       (clojure.walk/keywordize-keys)))

(re-frame/reg-event-fx
 ::set-route
 (fn-traced [db [_ route]]
            (when-not (nil? (get-token))  (re-posh/dispatch [::add-token (get-token)]))
            (case (:handler (:route route))
              :dashboard {:db (assoc db :route route)
                          :dispatch [::wevents/get-workspaces]}
              :dashboard-view {:db (assoc db :route route)
                               :dispatch [::wevents/get-workspace-data {:workspace-id (:id (:route-params (:route route)))}]}
              :folder-view {:db (assoc db :route route)
                            :dispatch [::wevents/get-projects {:workspace-id (:id (:route-params (:route route))) :folder-id (:folder-id (:route-params (:route route)))}]}
              :trash-view {:db (assoc db :route route)
                           :dispatch [::wevents/get-all-deleted {:workspace-id (:id (:route-params (:route route)))}]}
              :deleted-folder-view {:db (assoc db :route route)
                                    :dispatch [::wevents/get-projects {:workspace-id (:id (:route-params (:route route))) :folder-id (:folder-id (:route-params (:route route)))}]}
              :strive-forms {:db (assoc db :route route)
                             :dispatch [::forms-events/get-form-data {:form-id (:form_id (parse-params)) :query-params (.-search (.-location js/window)) :parsed-query-params (parse-params)
                                                                      :token (get-token)}]}
              {:db (assoc db :route route)})))

(re-frame/reg-event-fx
 ::auto-authenticate-user
 (fn [{:keys [ds]} [_ {:keys [token workspace-id]}]]
   (let []
     {:http-xhrio {:method          :get
                   :uri             (reauthenticate workspace-id)
                   :headers  {"Authorization"  (str "Bearer " token)
                              "Cache-Control"  "no-cache"}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :Referrer-Policy "http://localhost:8081"
                   :on-success      [:authenticate-sucsess]
                   :on-failure      [:endpoint-request-error]}})))

(re-posh/reg-event-ds
 ::add-token
 (fn-traced [_ [_ val]]
            [[:db/add 5 :user/token val]]))

(re-posh/reg-event-ds
 ::add-user-name
 (fn-traced [_ [_ val]]
            [[:db/add 5 :user/name val]]))

(re-posh/reg-event-ds
 ::add-user-email
 (fn-traced [_ [_ val]]
            [[:db/add 5 :user/email val]]))

(re-frame/reg-event-db
 :authenticate-sucsess
 (fn [ds [_ token]]
   (re-posh/dispatch [::add-token (:token token)])
   (re-posh/dispatch [::add-user-name (:display_name (js->clj (jwt-decode (:token token)) :keywordize-keys true))])
   (re-posh/dispatch [::add-user-email (:email (js->clj (jwt-decode (:token token)) :keywordize-keys true))])
   ((-> js/window .-CommandBar .-boot) (:id (js->clj (jwt-decode (:token token)) :keywordize-keys true)))
   (.setItem (.-localStorage js/window) "token" (:token token))
  ;;  (re-frame/dispatch [::navigate [:dashboard]])
   ))